module.exports = __webpack_public_path__ + "img/adminD 5.997c34c0.jpg";